<div class="report-page-root-container  weekly-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/reports.svg">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">

              <mat-form-field>
                <mat-label>Year</mat-label>
                <mat-select placeholder="Select a year" formControlName="year" (selectionChange)="onYearChange()">
                  <!-- Show loading state while waiting for data -->

                  <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                    {{ fy.display_year }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="week-no">
                <mat-label>Week No</mat-label>
                <mat-select formControlName="week_no">
                  <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                    {{ week.displayText }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <!-- Terminal Dropdown -->
            <div class="list-row terminals">
              <div class="header" (click)="isExpandedTerminal = !isExpandedTerminal">
                <div class="title-container">
                  <span class="title">Terminal</span> <span class="count" *ngIf="selectedTerminalSourcesCount>0">[
                    {{selectedTerminalSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedTerminal">
                    <button type="button" class="list-action-button" mat-icon-button
                      (click)="$event.stopPropagation(); showSelectedTerminalOnly = !showSelectedTerminalOnly"
                      [matTooltip]="showSelectedTerminalOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedTerminalOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button" mat-icon-button
                      (click)="$event.stopPropagation(); toggleSelectAllTerminal()" matTooltip="Select All/None">
                      <mat-icon>{{ getSelectAllIconTerminal() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedTerminal = !isExpandedTerminal">
                    <mat-icon>{{ isExpandedTerminal ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedTerminal" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Terminal" formControlName="terminalFilter">
                      <button *ngIf="editForm.get('terminalFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('terminalFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredTerminalListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sort Dropdown -->
            <!-- <div class="list-row sort">
              <div class="header" (click)="isExpandedSort = !isExpandedSort">
                <span>Sort</span>
                <div class="toggle-action-container">
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedSort = !isExpandedSort">
                    <mat-icon>{{ isExpandedSort ? "expand_less" : "expand_more" }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedSort" class="list" style="height: auto; min-height: unset;">
                <div class="row" style="padding: 10px; display: flex; gap: 10px; width: 100%;">
                  <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Sort Order</mat-label>
                    <mat-select formControlName="sort_order">
                      <mat-option *ngFor="let option of sortOrderOptions" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Sort By</mat-label>
                    <mat-select formControlName="sort_by">
                      <mat-option *ngFor="let option of sortOptions" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div> -->

            <div class="row">
              <div>

                <mat-checkbox [checked]="editForm.get('excludeSales')?.value === 1"
                  (change)="editForm.get('excludeSales')?.setValue($event.checked ? 1 : 0)"></mat-checkbox>
                Exclude sales details

              </div>


              <div>

              </div>

            </div>
            <div class="row">
              <div>

                <mat-checkbox [checked]="editForm.get('excludeExpense')?.value === 1"
                  (change)="editForm.get('excludeExpense')?.setValue($event.checked ? 1 : 0)"></mat-checkbox>
                Exclude expenses details

              </div>


              <div>

              </div>

            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>